
// Blog
if ($('.blog').length){
  $(window).on('scroll resize', function () {
    if ($(window).outerWidth() > 768) {
      let img = $('.blog-img-container').outerHeight();
      let blog = $('.blog-content').parent().outerHeight();
      let scroll = $(window).scrollTop();

      if (scroll < (blog - img) ) {
        $('.blog-img-container').css('margin-top', scroll);
      }
      else {
        $('.blog-img-container').css('margin-top', blog - img);
      }

    }
    else {
      $('.blog-img-container').css('margin-top', 0);
    }
  });
}


//Single Chalet
if ($('.chalet_single--details').length) {
  $(window).on('scroll resize', function () {
    if (($(window).outerWidth() > 1290)) {
      let calender = $('.desktop-calendar .chalet_single--calender').outerHeight();
      let bg = $('.chalet_hero--bg').outerHeight() ;
      let chalet = $('.chalet_details--inner').outerHeight();
      let scroll = $(window).scrollTop();

      if (scroll < (chalet - calender + bg) && (scroll > bg) ) {
        $('.chalet_single--calender').css('margin-top', (scroll - bg));
      }
      else if (scroll <= bg) {
        $('.chalet_single--calender').css('margin-top', 0);
      }
      else {
        $('.chalet_single--calender').css('margin-top', (chalet-calender)+'px' );
      }

    }
    else {
      $('.chalet_single--calender').css('margin-top', 0);
    }
  });
}

// Single event
/*
if ($('.event-single').length){
  $(window).on('scroll resize', function () {

    let sections = $('.event-single');

    if ($(window).outerWidth() > 768) {
      let scroll = $(window).scrollTop();
      let bg = $('.events-hero').outerHeight() ;
      let block = $('.block-details').outerHeight();
      let btn = $('.contact-button').outerHeight();
      let eventPadding = 0;

      sections.each(function () {

        let padding = parseInt($(this).css('padding-top')) + parseInt($(this).css('padding-bottom'));
        let img = $(this).find('.event-img-container').outerHeight() + 40;
        img = img + block + btn;
        bg = bg + eventPadding;
        let event = $(this).find('.event-details').outerHeight();
        eventPadding = event + padding;
        console.log(event, img)
        if(event>img){

          
          if (scroll < (event - img + bg) && (scroll > bg) ) {
            $(this).find('.event-img-container').css('margin-top', (scroll - bg - 80));
          }
          else if (scroll <= bg) {
            $(this).find('.event-img-container').css('margin-top', 0);
          }
          else {
            $(this).find('.event-img-container').css('margin-top', event - img - 80);
          }
        }
      });
    }
    else {
      sections.each(function () {
        $(this).find('.event-img-container').css('margin-top', 0);
      });
    }
  });
}
*/